/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EventCreateResponseDto } from '../../models/event-create-response-dto';
import { EventDto } from '../../models/event-dto';

export interface AddEvent$Params {
      body: EventDto
}

export function addEvent(http: HttpClient, rootUrl: string, params: AddEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<EventCreateResponseDto>> {
  const rb = new RequestBuilder(rootUrl, addEvent.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EventCreateResponseDto>;
    })
  );
}

addEvent.PATH = '/api/harvests/event';
